import { UntypedFormControl } from '@angular/forms';
import { DISPLAY_TYPES } from '../../constants/adjustments-and-reclasses/displayTypes.constant';
import { NumericCell } from './NumericCell.type';
import { StyleClassType } from './StyleClassType.type';

/**
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html
 * we are using the type variable here for type narrowing
 * so that upon a check on the string being of certain value typescript knows the type being referenced exactly and enforce check on it
 * each type here is a type of cell, a cell can be display of a special kind, numeric, date, or text,
 * and can be editable or an action or expand action
 */
export type CellDisplayType = DefaultCellConfiguration &
    (NumericCell | TextCell | TranslatableCell | DateCell | IncomeAccountSelectionCell | ActionCell | ExpandAction);

type TextCell = { readonly value: string; type?: undefined | null | typeof DISPLAY_TYPES.string };
type TranslatableCell = { readonly value: string; type: typeof DISPLAY_TYPES.translate };
type DateCell = { readonly value: string; type: typeof DISPLAY_TYPES.date };
type IncomeAccountSelectionCell = { type: typeof DISPLAY_TYPES.incomeAccount };
type ActionCell = { type: typeof DISPLAY_TYPES.action; action: (value: MouseEvent) => void; extraClass: string };
type ExpandAction = { type: typeof DISPLAY_TYPES.expandAction };
type DefaultCellConfiguration = { class: StyleClassType; control?: UntypedFormControl | null; editable?: boolean };
